<template>
  <div class="feedback">
    <div class="send" @click="sendMessage" v-show="visible">
      {{ $t('send') }}
    </div>
    <div class="text">
      <div style="background-color: #FFF; position: relative;">
        <!-- <span v-show="!message" class="placeholder">{{
          $t('feedback_placeholder')
        }}</span> -->
        <textarea
          ref="fb"
          rows="12"
          :placeholder="$t('feedback_placeholder')"
          v-model.trim="message"
          :class="{ error: (send || len) && (len > 200 || len < 10) }"
          @blur="blurIn"
        >
        </textarea>
        <span class="tip">{{ len }}/200</span>
      </div>
    </div>
    <div class="text" v-if="!user.phone">
      <label for="phone">{{ $t('contact_method') }}</label>
      <input
        id="phone"
        @blur="blurIn"
        v-model.trim="phone"
        :placeholder="
          isMC() ? $t('contact_placeholder1') : $t('contact_placeholder')
        "
        :class="{
          error:
            !isMC() && (send || phone) && !/^1(3|4|5|7|8)\d{9}$/.test(phone),
        }"
      />
    </div>
  </div>
</template>

<script>
/* eslint-disable no-undef */
import { mapGetters } from 'vuex'
import { compareVersion } from '@duoke/tools'
import native, { isMC } from '@/utils'

const base = {
  21: '2.6.0', // IOS Air-黑端企业版
  31: '2.6.0', // IOS Air-黑端标准版
  22: '2.9.0', // IOS Air-红端企业版
  32: '2.9.0', // IOS Air-红端标准版
  41: '2.4.0', // Android Air-黑端
  42: '2.5.0', // Android Air-红端
}

const { NativeFuncs, callNativeAsyncFunc, appInfo } = native
export default {
  name: 'feedback',
  data() {
    return {
      message: '',
      phone: '',
      send: false,
      isRequest: false,
      visible: false,
    }
  },
  created() {
    callNativeAsyncFunc(NativeFuncs.SYSTEM.OPEN_WINDOW, {
      type: 'bugtraceFeedback',
    })
  },
  mounted() {
    this.$store.dispatch('requestBannerList')
    setTimeout(() => {
      this.visible = true
    }, 300)
  },
  activated() {
    // document.documentElement.classList.add('feed')
    this.send = false
    this.$nextTick(() => {
      this.$refs.fb.click()
      this.$refs.fb.focus()
      setTimeout(() => {
        const { projId, appVersion } = appInfo || {}
        if (
          projId &&
          appVersion &&
          base[projId] &&
          compareVersion(appVersion, base[projId])
        ) {
          callNativeAsyncFunc(NativeFuncs.SYSTEM.CLOSE)
        }

        this.visible = true
      }, 300)
    })
  },
  deactivated() {
    // document.documentElement.classList.remove('feed')
    this.visible = false
  },
  computed: {
    len() {
      return this.message.length
    },
    scrollHeight() {
      return document.documentElement.scrollTop || document.body.scrollTop || 0
    },
    ...mapGetters({
      user: 'getUserInfo',
    }),
  },
  methods: {
    isMC,
    sendMessage() {
      this.send = true
      const phone = this.phone || this.user.phone
      if (this.len < 10) {
        this.$toast({
          type: 'none',
          text: i18n.t('feedback_validate1'),
        })
      } else if (this.len > 200) {
        this.$toast({
          type: 'none',
          text: i18n.t('feedback_validate2'),
        })
      } else if (!/^1(3|4|5|7|8)\d{9}$/.test(phone) && !isMC()) {
        this.$toast({
          type: 'none',
          text: i18n.t('feedback_validate3'),
        })
      }
      if (
        !this.isRequest &&
        this.len <= 200 &&
        this.len >= 10 &&
        (isMC() || /^1(3|4|5|7|8)\d{9}$/.test(phone))
      ) {
        this.isRequest = true
        setTimeout(() => {
          this.isRequest = false
        }, 2000)
        this.$store
          .dispatch('sendMessage', {
            phone,
            content: this.message,
          })
          .then((res) => {
            if (res.status === 204) {
              this.$toast({ text: `${i18n.t('submit')}${i18n.t('success')}` })
              setTimeout(() => {
                this.phone = ''
                this.message = ''
                if (this.$route.name === 'feed') {
                  window.location.href = 'obj-c::closeWindows'
                } else this.$router.back()
              }, 300)
            } else {
              this.$toast({
                type: 'fail',
                text: res.msg || `${i18n.t('submit')}${i18n.t('fail')}`,
              })
            }
          })
          .catch((e) => {
            console.log(e)
            this.$toast({
              type: 'none',
              text: i18n.t('submit_error'),
            })
          })
      }
    },
    blurIn() {
      window.scrollTo(0, Math.max(this.scrollHeight - 1, 0))
    },
  },
  watch: {
    message(nValue) {
      if (nValue.length > 200) {
        this.message = nValue.slice(0, 200)
      }
    },
  },
}
</script>

<style lang="scss">
// .feed {
//   .header {
//     position: fixed;
//   }
// .feedback {
//   margin-top: 40px;
//   min-height: 400px;
// }

.iPhone {
  // &.iPhone {
  // .header {
  //   padding-top: 20px;
  //   padding-top: constant(safe-area-inset-top);
  //   padding-top: env(safe-area-inset-top);
  // }
  .feedback {
    .send {
      top: 20px;
      top: constant(safe-area-inset-top);
      top: env(safe-area-inset-top);
    }
  }
}
// }
</style>



// WEBPACK FOOTER //
// src/views/help-center/views/FeedbackView.vue